import { render, staticRenderFns } from "./StripePage.vue?vue&type=template&id=2e497df4&scoped=true"
import script from "./StripePage.vue?vue&type=script&lang=js"
export * from "./StripePage.vue?vue&type=script&lang=js"
import style0 from "./StripePage.vue?vue&type=style&index=0&id=2e497df4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e497df4",
  null
  
)

export default component.exports